import React from 'react';
import { useTranslation } from 'react-i18next';
import SMJCampaignItem from './SMJCampaignItem';

const SMJAvailableCmpList = ({ campaigns, onSelect, selection, requestModelByRMTypeId }) => {
  const { t } = useTranslation();
  return Object.entries(campaigns).map(([rmId, list]) =>
    list.map(cmp => (
      <SMJCampaignItem
        checked={selection.indexOf(cmp.key) !== -1}
        title={t(`smartmessaging.campaigns.grouped.campaignModel.name.${cmp.key}`)}
        description={t(`smartmessaging.campaigns.grouped.campaignModel.description.${cmp.key}`)}
        type={t(`smartmessaging.requestmodel.label.${requestModelByRMTypeId[rmId].name}`)}
        key={cmp.key}
        onSelect={checked => {
          onSelect(cmp.key, checked);
        }}
      />
    ))
  );
};

export default SMJAvailableCmpList;
